import { FarmCarbonTable } from '@/components/tables/carbon-info-table.component';
import { FarmBasicInfoTable } from '@/components/tables/farm-basic-info-table';
import { H3 } from '@/components/typography/heading/headings.component';
import { cn } from '@/lib/utils';
import { FarmData } from '@/modules/Report/Report.schema';

export type Props = {
  data: FarmData;
  className?: string;
};

export const FarmCarbonInfoTable = ({ data, className }: Props) => {
  return (
    <div className={cn('gap-3', className)}>
      <H3>Farm Carbon Information</H3>
      {data && (
        <div className={cn('flex flex-col')}>
          <FarmBasicInfoTable data={data} />
          <FarmCarbonTable data={data} />
        </div>
      )}
    </div>
  );
};
